<div class="tabs_content">
    <div class="filter_div">
        <ul class="d-flex align-items-center">
            <li>
                <img src="../../../../assets/images/calender.png" [style.height.px]="cal_img_height"/>
            </li>
            <li class="px-1">
                <div class="dropdown">
                    <button class="dropbtn filter_btn" [style.paddingTop.px]="filter_btn_padding" [style.paddingBottom.px]="filter_btn_padding">{{selectedDateRange}}</button>
                    <div class="dropdown-content">
                    <a routerLink="" (click)="setDateRange('7 Days')">Past 7 Days</a>
                    <a routerLink="" (click)="setDateRange('1 Month')">Past 1 Month</a>
                    <a routerLink="" (click)="setDateRange('3 Months')">Past 3 Months</a>
                    <a routerLink="" (click)="setDateRange('6 Months')">Past 6 Months</a>
                    <a routerLink="" (click)="setDateRange('9 Months')">Past 9 Months</a>
                    <a routerLink="" (click)="setDateRange('Year')">Last Year</a>
                    </div>
                </div>
            </li>
            <li>
                <mat-form-field class="example-form-field w-auto" appearance="fill" [style.height.px]="cal_img_height">
                    <mat-date-range-input [rangePicker]="rangePicker" [max]="maxDate" [min]="minDate">
                      <input matStartDate placeholder="Start date" [(ngModel)]="selectedStartDate" appDateFormat>
                      <input matEndDate placeholder="End date" [(ngModel)]="selectedEndDate" appDateFormat>
                    </mat-date-range-input>
                  
                    <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                  
                    <mat-date-range-picker #rangePicker (closed)="onDateRangeClosed()">
                      <mat-date-range-picker-actions>
                        <!-- Uncomment if needed -->
                        <!-- <button mat-button matDateRangePickerCancel (click)="resetDateRange()">Cancel</button> -->
                        <button mat-raised-button color="primary" matDateRangePickerApply class="btn btn-info btn-sm bg-main text-white" (click)="applyClicked=true;">
                          Apply
                        </button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
            </li>
        </ul>
    </div>
</div>